import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import { map, startWith } from "rxjs/operators";
import swal from "sweetalert2";
import { GrnService } from "../../../services/grn.service";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service
} from "../../../services/index";
//import { PurchaseEvents } from './PurchaseEvents';
import { PurchaseOrderService } from "../../../services/purchaseorder.service";

import { SalesPlanService } from "../../../services/salesplan.service";


@Component({
  selector: "add-Edit-Purchase-Order",
  templateUrl: "./addEditPurchaseOrder.html",
})
export class AddEditPurchaseOrder {
  auto_number: number;
  season_name: string;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: "0", totalamt: "0" };
  qualityList: any;
  typeList: any;
  coreList: any;
  shadeIndex: number = 0;
  gangList: any;
  coredesignList: any;
  gangdesignList: any;
  shadeTypeList: any = [];
  shadeTypeListExists: any = [];
  purchaseAgentList = [];


  varietyList = [];
  varietyList1 = [];
  styleList1: any;
  shirtStyle = ["FORMAL", "CASUAL", "CLUB", "RR DHOTI", "RR FORMAL", "RR CASUAL",];
  colorTypeList: any = [];
  editShadeOpen: boolean = false;
  colorList: any;
  codeList: any = [];
  shadeType = "";
  shadeColor = "";
  widthList: any[];
  designTypeList = ["NEW", "CORE", "GANG"];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  mode: string;
  saveEvent: any;
  temp: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
    this.designdata = designdata;
    if (this.mode == "Edit" || this.mode == "View") {
      // this.designdata.po_date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.designdata.party_name = designdata.party_name;
      this.designdata.date = designdata.entry_date;
      this.temp = designdata.less_value
      this.loadeditdesignlist();
    }
    else if(this.mode == "Convert") {
      this.loadplainPoEst(val["data"].ref_id);
      this.designdata.style = val["data"].style;
      this.designdata.party_code = val["data"].party_name;
      this.designdata.width = val["data"].width;
      setTimeout(() => {
        this.onClickCode(val["data"].party_name) 
      }, 4000);
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  filteredOptions: Observable<string[]>;
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private combo: Combo2Service,
    private grn: GrnService,
    private poservice: PurchaseOrderService,
    private salesServ: SalesPlanService

  ) {
    //   $('#modalCart').modal({
    //     show: false
    //  });
    this.row = {
      design_type: "NEW",
      design_no: "",
      shade: "",
      fabric_design: "",
      style: "",
      shirt_style: "",
      // fabric_shade: "",
      quality: "",
      variety_type: "",
      type: "",
      color: "",
      sample_cut: "NO",
      swatch_cut: "NO",
      act_color: "",
      width: "",
      each_clr_mtr: 0,
      qty: 0,
      mtrs: 0,
      rate: 0,
      amount: 0,
      no_of_clrs: 0,
      appr_shrts: 0
      // less_value: 0,
    };
    this.data = {
      designList: [],
    };
    let row = Object.assign({}, this.row);
    this.data.designList.push(row);
  }
  ngOnInit() {
    if (this.mode == "Edit") {
      setTimeout(() => {
        this.editShadeOpen = true;
      }, 1000);
    } else if (this.mode == "Add") {
      this.editShadeOpen = true;


    }
    this.codelist();
    this.qualitylist();
    // this.getVarietyList();
    this.typelist();
    this.colorlist();
    this.widthlist();
    this.lrlist();
    // this.styleList();
    this.tableScroll();
    if (this.mode == "Add" || this.mode == "Convert") {
      this.designdata.po_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      this.designdata.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.getAuto();
    }
    this.filteredOptions = this.parentCtrl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.codeList.filter((option) =>
      option.code.toLowerCase().includes(filterValue)
    );
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#date").focus();
    }, 100);
  }
  tableScroll() {
    $(".purreturn").height(window.innerHeight - 60);
    $(".pobody").width(window.innerWidth - 30);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      design_no = this.data.designList[ind]["design_no"],
      quality = this.data.designList[ind]["quality"],
      type = this.data.designList[ind]["type"],
      shade = this.data.designList[ind]["shade"],
      color = this.data.designList[ind]["color"],
      a_color = this.data.designList[ind]["a_color"],
      //  width = this.data.designList[ind]['width'],
      mtrs = this.data.designList[ind]["mtrs"],
      qty = this.data.designList[ind]["qty"],
      rate = this.data.designList[ind]["rate"],
      amt = this.data.designList[ind]["amt"],
      design_type = this.data.designList[ind]["design_type"],
      variety_type = this.data.designList[ind]["variety_type"];

    let nxtRow = $("#row-" + ind).next("tr");

    if (fld == "variety_type" && nxtRow.length == 0) {
      let len = this.data.designList.length;
      let design_no = this.data.designList[len - 1].design_no;
      let type = this.data.designList[len - 1].type;
      let color = this.data.designList[len - 1].color;
      this.row.variety_type = variety_type;
      this.row.quality = quality;
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "variety_type" + "-" + nxtInd).focus();

      if (design_no != "" && nxtInd == len) {
        this.data.designList.push(rowdetail);
        setTimeout(() => {
          $("#variety_type" + "-" + nxtInd).focus();
        }, 500);
      } else if (design_no == "" && nxtRow == len) {
        let a = nxtInd;
        setTimeout(() => {
          $("#variety_type" + "-" + a).focus();
        }, 500);
      } else {
        $("#" + "totalamt").focus();
      }

      //  nxtInd = this.data.designList.length - 1;
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.designList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.designList.length > 1) {
          that.data.designList.splice(ind, 1);
          $("#amt" + "-" + (ind - 1)).focus();

          // if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
          //   $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          // } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
          //   $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          // }
        }
        that.calcTotal();
      },
      function (dismiss) { }
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAuto() {
    this.poservice.getAuto({}).then((res: any) => {
      this.designdata.po_no = res;
    });
  }
  qualitylist() {
    this.poservice.qualitylist({}).then((res: any) => {
      this.qualityList = res.data;
    });
  }



  getVarietyList() {
    this.combo.varietyStylePoCombo({ style: this.designdata.style }).then((res: any) => {

      let list = [...res.data];
  
      this.varietyList = list.reduce((unique, o) => {
        if (!unique.some(obj => obj.variety === o.variety)) {
          unique.push(o);
        }
        return unique;
      }, []);

      this.varietyList1 = this.varietyList;

      this.styleList1 = list.reduce((unique, o) => {
        if (!unique.some(obj => obj.style === o.style)) {
          unique.push(o);
        }
        return unique;
      }, []);

    });

  }

  typelist() {
    this.poservice.typelist({}).then((res: any) => {
      this.typeList = res.data;
    });
  }
  colorlist() {
    this.poservice.colorlist({}).then((res: any) => {
      this.colorList = res.data;
    });
  }
  widthlist() {
    this.poservice.widthlist({}).then((res: any) => {
      this.widthList = res.data;
    });
  }
  lrlist() {
    this.grn.getLrList({}).then((res: any) => {
      this.auto_number = res.auto_design;
      this.season_name = res.season;

      // if (this.mode == 'Edit') {
      //   let params = {
      //     date: this.designdata.date,
      //   };
      //   this.poservice.CheckSeasonExist(params).then((res: any) => {
      //     this.season_name = res.season;
      //     console.log(res);
      //     if (res.data.length == 0) {
      //       swal({
      //         title: "Selected Date is invalid",
      //         type: "warning",
      //         showCancelButton: false,
      //         showConfirmButton: false,
      //         timer: 1000,
      //       });
      //       this.designdata.date = "";
      //       return
      //     }
      //   });
      // }

    });

  }
  CheckSeason() {
    if (this.mode == 'Edit') {

      let temp = this.designdata.date
      let data = temp.getFullYear() + '-' + temp.getMonth() + '-' + temp.getDate()
      let params = {
        date: data,
      };

      this.poservice.CheckSeasonExist(params).then((res: any) => {
        this.season_name = res.data[0].season;

  
        if (res.data.length == 0) {
          swal({
            title: "Selected Date is invalid",
            type: "warning",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1000,
          });
          this.designdata.date = "";
          return
        }
      });
    }
  }
  styleList() {
    this.poservice.styleList({}).then((res: any) => {
      // this.styleList1 = res.data;

    });
  }
  coreGangList() {
    let params = {
      party_id: this.designdata.party_id,
    };
    let that = this;
    that.poservice.coreGangList(params).then((res: any) => {
      that.coreList = res.coreList;
      // that.coredesignList = Array.from(new Set(that.coreList.map((item: any) => item.design_no && item.party_rate)));
      let mymap = new Map();

      that.coredesignList = that.coreList.filter((el) => {
        const val = mymap.get(el.design_no);
        if (val) {
          if (el.design_no < val) {
            mymap.delete(el.design_no);
            mymap.set(el.design_no, el.party_rate);
            return true;
          } else {
            return false;
          }
        }
        mymap.set(el.design_no, el.party_rate);
        return true;
      });

      // that.gangList = res.gangList;

      // let mymap1 = new Map();
      // that.gangdesignList = that.gangList.filter((el) => {
      //   const val = mymap1.get(el.design_no);
      //   if (val) {
      //     if (el.design_no < val) {
      //       mymap1.delete(el.design_no);
      //       mymap1.set(el.design_no, el.party_rate);
      //       return true;
      //     } else {
      //       return false;
      //     }
      //   }
      //   mymap1.set(el.design_no, el.party_rate);
      //   return true;
      // });

      // that.gangdesignList = Array.from(
      //   new Set(
      //     that.coreList.map((item: any) => item.design_no && item.party_rate)
      //   )
      // );
    });
  }
  codelist() {
    this.poservice.codelist({}).then((res: any) => {
      this.codeList = res.data;
      if (this.mode == "Edit") {
        this.partyCtrl.setValue(this.designdata["party_name"]);
        this.onClickCode(this.designdata.party_code);
      }
    });
  }
  getAgentList(party_id) {
    let params = {
      party_id: party_id,
    };
    this.poservice.agentlist(params).then((res: any) => {
      if (res.success) {
        this.designdata.agent = res.data[0].agent_name;
        this.designdata.agent_id = res.data[0].agent_id;
      } else {
        this.designdata.agent = "";
        this.designdata.agent_id = 0;
      }
    });
  }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.codeList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_name: id });
      this.designdata.party_id = fitem["party_id"];
      return fitem["party_name"];
    }
    return "";
  }
  calctot(event, ind) {
    let designData = this.data.designList[ind];
    let rate = parseFloat(designData.rate);
    let mtrs = parseFloat(designData.mtrs);
    // let less_value = designData.less_value;
    let less_value = 0;
    if (this.designdata.less_value && !isNaN(rate)) {
      less_value = parseFloat(this.designdata.less_value);
    }

    if (isNaN(rate)) {
      rate = 0;
    }
    let amount = rate * mtrs - less_value * mtrs;
    designData.amount = parseFloat(amount.toFixed(3));
    this.calcTotal();
  }
  CalcordTot(i){
    let designData = this.data.designList[i];
    let clrs = parseFloat(designData.no_of_clrs);
    let clr_mtrs = parseFloat(designData.each_clr_mtr);
    let mtrs = clrs * clr_mtrs;
    designData.mtrs = parseFloat(mtrs.toFixed(3));
    // console.log(this.data.designList[i]);
    this.calctot('', i);
  }
  addShade(colorShade) {
    let exists = this.shadeTypeList.findIndex((el) => el.color == colorShade);
    if (exists != -1) {
      swal("Color already exists");
    } else if (colorShade != "" && colorShade) {
      // if (this.data.designList[this.shadeIndex].variety_type == "PLAIN") {
      if (this.designdata.style == 'RR FORMAL' || this.designdata.style == 'RR CASUAL') {

        let des_no = this.data.designList[this.shadeIndex].design_no;
        let coreExists = this.coreList.findIndex(
          (el) => el.design_no == des_no && el.color == colorShade
        );
        if (coreExists != -1) {

          this.shadeColor = this.coreList[coreExists].color;
          this.colorTypeList.push(this.coreList[coreExists].color);

          let pushShadeColor = {
            color: this.shadeColor,
          };
          // this.shadeTypeList.push(pushShadeColor);
          this.shadeTypeList.push(this.coreList[coreExists]);

        } else {
          swal({
            title: "INVALID SHADE FOR THIS CORE DESIGN",
            type: "error",
            text: "PLEASE ENTER VALID SHADE",
            confirmButtonText: "Ok!",
          });
        }
      }
      // else if (this.data.designList[this.shadeIndex].design_type == "GANG") {
      //   let des_no = this.data.designList[this.shadeIndex].design_no;
      //   let gangExists = this.gangList.findIndex(
      //     (el) => el.design_no == des_no && el.shade == shade
      //   );
      //   if (gangExists != -1) {

      //     this.shadeColor = this.coreList[gangExists].color;
      //     this.colorTypeList.push(this.gangList[gangExists].color);

      //     let pushShadeColor = {
      //       shade: shade,
      //       color: this.shadeColor,
      //     };
      //     this.shadeTypeList.push(pushShadeColor);
      //   } else {
      //     swal({
      //       title: "INVALID SHADE FOR THIS GANG DESIGN",
      //       type: "error",
      //       text: "PLEASE ENTER VALID SHADE",
      //       confirmButtonText: "Ok!",
      //     });
      //   }
      // } 
      else {
        let pushShadeColor = {
          color: colorShade,
        };
        this.colorTypeList.push(colorShade);
        this.shadeTypeList.push(pushShadeColor);
        $("#shadeType").focus();
      }
      this.shadeType = "";
      this.shadeColor = "";
    }
  }
  onClickShade() {
    this.shadeTypeList = this.shadeTypeList.filter((el) => el.shade != "");
    let no_of_clrs = this.shadeTypeList.length > 0 ? this.shadeTypeList.length : 0;
    this.data.designList[this.shadeIndex].shade = this.shadeTypeList.toString();
    this.shadeTypeListExists.splice(this.shadeIndex, 1, [...this.shadeTypeList]);
    this.data.designList[this.shadeIndex].shade = this.shadeTypeList
      .map((el) => el.shade)
      .toString();

    this.data.designList[this.shadeIndex].color = this.shadeTypeList
      .map((el) => el.color)
      .toString();
    this.data.designList[this.shadeIndex].no_of_clrs = no_of_clrs;
  
    this.onclickpdcode(
      this.data.designList[this.shadeIndex].design_no,
      this.data.designList[this.shadeIndex].color,
      this.shadeIndex,
      "design"
    );
    $("#no_of_clrs" + "-" + this.shadeIndex).focus();
    this.shadeIndex = 0;
  }
  onclickpdcode(designshade, shade, ind, canShowSwal) {
    let des_no = designshade;
    let party_shade = shade;
    let party_id = this.designdata.party_id;

    // if (this.data.designList[ind].variety_type == "PLAIN" && des_no != "") {
    if ((this.designdata.style == 'RR FORMAL' || this.designdata.style == 'RR CASUAL') && des_no != "") {

      let coreExists = this.coreList.filter(
        (el) => el.design_no == des_no && el.party_id == party_id
      );

      if (coreExists && coreExists.length > 0) {
        this.data.designList[ind].fabric_design =
          coreExists[0]["core_designno"];
        // this.data.designList[ind].style = coreExists[0]["fabric_style"];
        this.data.designList[ind].shirt_style = coreExists[0]["shirt_style"];
        this.data.designList[ind].quality = coreExists[0]["quality"];
        this.data.designList[ind].width = coreExists[0]["width"];
        this.data.designList[ind].isNew = false;
      } else {
        swal({
          title: "INVALID PLAIN DESIGN",
          type: "error",
          text: "PLEASE ENTER VALID DESIGN",
          confirmButtonText: "Ok!",
        });
    
      }

    }
    // else if (
    //   this.data.designList[ind].design_type == "GANG" &&
    //   des_no != ""
    // ) {
    //   let gangExists = this.gangList.filter(
    //     (el) => el.design_no == des_no && el.party_id == party_id
    //   );
    //   if (gangExists && gangExists.length > 0) {
    //     this.data.designList[ind].fabric_design =
    //       gangExists[0]["core_designno"];
    //     // this.data.designList[ind].style = gangExists[0]["fabric_style"];
    //     this.data.designList[ind].shirt_style = gangExists[0]["shirt_style"];
    //     this.data.designList[ind].quality = gangExists[0]["quality"];
    //     this.data.designList[ind].width = gangExists[0]["width"];
    //     this.data.designList[ind].isNew = false;
    //   } else {
    //     swal({
    //       title: "INVALID GANG DESIGN",
    //       type: "error",
    //       text: "PLEASE ENTER VALID GANG DESIGN",
    //       confirmButtonText: "Ok!",
    //     });
    //   }
    // } 
    
    //For Dhoti Items Only
    else if (this.data.designList[ind].design_type == "NEW" && des_no != "" && this.designdata.style == 'RR DHOTI') {
      
      this.data.designList[ind].fabric_design = this.data.designList[ind].design_no + "-D";
    }
    else if (this.data.designList[ind].design_type == "NEW" && des_no != "") {

      this.onClickDesign(des_no, party_shade, ind, canShowSwal);
    }

    // if (res.color.length > 0) {
    //   this.colorList = res.color;
    // } else {
    //   this.colorList = this.colorListback;
    // }
  }
  onClickDesign(designno, party_shade, ind, canShowSwal) {
    let des_no = designno;
    let des_shade = party_shade;

    for (let i = 0; i < this.data.designList.length; i++) {
      if (i != ind && designno == this.data.designList[i].design_no) {
        let fabric_design = this.data.designList[i].fabric_design;
        this.data.designList[ind].fabric_design = fabric_design;
        if (this.data.designList[i].variety_type == 'MAIN FAB' || this.data.designList[i].variety_type == 'MATCH FAB' && (this.data.designList[ind].fabric_design.split(' ')[1] != this.data.designList[ind].variety_type.split(' ')[0])) {
        // Match The Fab.Design With Variety
          this.data.designList[ind].fabric_design = fabric_design.split(' ')[0] + ' '+ this.data.designList[ind].variety_type.split(' ')[0];

        }
        if (this.data.designList[i].isNew == true) {
          this.data.designList[ind].isNew = false;
        }

        return;
      }
    }
    this.generateOdNo(des_no, des_shade, ind, canShowSwal);
  }
  generateOdNo(des_no, design_shade, ind, canShowSwal) {

    if (this.mode == 'Edit') {
      return
    }
    let params = {
      design_shade: design_shade,
      des_no: des_no,
      party_id: this.designdata.party_id,
      variety: this.data.designList[ind].variety_type,
      entry_style: this.designdata.style
    };
    let that = this;
    that.grn.getAutoDesignNo(params).then((res: any) => {
      that.data.designList[ind].fabric_design = that.isSameDesignNo(
        des_no,
        res.design_no,
        ind,
        design_shade,
        res.newExists,
        res.coreExists,
        res.type,
        canShowSwal
      );
      //   if(that.data.designList[ind].design_type == "NEW" && !res.coreExists){
      //   // that.data.designList[ind].fabric_design = 10 + that.data.designList[ind].fabric_design;
      //   var temp = 0
      //  temp = 10 + that.data.designList[ind].fabric_design;
      //  that.data.designList[ind].fabric_design = temp
      //   }
      // console.log("Is Exists From Here")
    });
  }

  isSameDesignNo(
    party_des_no,
    res,
    ind,
    pd_code,
    newExists,
    coreExists,
    type,
    canShowSwal
  ) {

    //
    for (let i = 0; i < this.data.designList.length - 1; i++) {
      if (
        ind != i &&
        res == this.data.designList[i].fabric_design &&
        party_des_no != this.data.designList[i].design_no
      ) {
        if (this.data.designList[ind].design_type == "NEW" && !coreExists && this.designdata.style == 'CLUB') {

          var data = res.match(/(\d+)/);
          res = Number(data[0])
          res = res + 1;
          res = res + ' ' + this.data.designList[ind].variety_type.split(' ')[0]

        }
        else {
          res = res + 1;
        }
        this.isSameDesignNo(
          party_des_no,
          res,
          ind,
          pd_code,
          newExists,
          coreExists,
          type,
          canShowSwal
        );
      }
    }
    if (
      Object.entries(newExists).length > 0 &&
      party_des_no != "" &&
      canShowSwal == "design"
    ) {
      swal({
        title: "LAST GENERATED DETAILS " + party_des_no + " - " + res,
        html:
          "PARTY CODE : " +
          newExists.party_code +
          "<br/>" +
          "PO NO : " +
          newExists.po_no +
          "<br/>" +
          " PO DATE : " +
          newExists.po_date +
          "<br/>",
      });
      this.data.designList[ind].isNew = false;

    } else {
      this.data.designList[ind].isNew = true;
    }
    return res;


  }

  CalcMainVal(i) {
    this.data.designList[i].main_fabval = this.data.designList[i].main_fabmtr * this.data.designList[i].main_fabrate
  }

  CalcMatchVal(i) {
    this.data.designList[i].mat_fabval = this.data.designList[i].mat_fabmtr * this.data.designList[i].mat_fabrate

    this.data.designList[i].amount = this.data.designList[i].mat_fabval + this.data.designList[i].main_fabval
    this.data.designList[i].mtrs = this.data.designList[i].mat_fabmtr + this.data.designList[i].main_fabmtr

    if (this.designdata.width == '36')
      this.data.designList[i].appr_shrts = (this.data.designList[i].mtrs / 2.50).toFixed(0)
    else if (this.designdata.width == '44')
      this.data.designList[i].appr_shrts = (this.data.designList[i].mtrs / 1.80).toFixed(0)
    else
      this.data.designList[i].appr_shrts = (this.data.designList[i].mtrs / 1.60).toFixed(0)

    this.calcMeter();
    this.calcTotal();
  }
  verifyShade(shade, ind) {
    if (this.designdata.style == 'RR FORMAL' || this.designdata.style == 'RR CASUAL') {
   
      let des_no = this.data.designList[ind].design_no;
      let coreExists = this.coreList.findIndex(
        (el) => el.design_no == des_no && el.shade == shade
      );
      if (coreExists != -1) {

        this.data.designList[ind].color = this.coreList[coreExists].color;
        this.data.designList[ind].shade = this.coreList[coreExists].shade;
        this.data.designList[ind].no_of_clrs = 1;


      }
      else {
        swal({
          title: "INVALID SHADE FOR THIS DESIGN",
          type: "error",
          text: "PLEASE ENTER VALID SHADE",
          confirmButtonText: "Ok!",
        });

        this.data.designList[ind].color = "";
        this.data.designList[ind].shade = "";
      }
    }
  }
  openModalShade(index, design) {
    this.shadeIndex = index;
    this.shadeIndex = index;
    if (design.design_no != "" && this.editShadeOpen) {
      if (this.data.designList[index].shade != "") {
        //   this.shadeTypeList = this.shadeTypeList.filter((el) => el.shade != "");
        //   this.shadeTypeList = String(this.shadeTypeList
        // .map((el) => {
        //   let obj = {
        //     shade : el.shade,
        //     color : el.color
        //   }
        //   return obj;
        // })).split(
        //     ","
        //   );
        this.shadeTypeList = this.shadeTypeListExists[this.shadeIndex];
      } else {
        this.shadeTypeList = [];
        this.colorTypeList = [];
      }
      $("#modalCart").modal("show");
      setTimeout(() => {
        $("#shadeType").focus();
      }, 500);
    }
  }

  clearShade(ind) {
    this.shadeTypeList.splice(ind, 1);
    this.colorTypeList.splice(ind, 1);
  }

  moneyFormat(nStr) {
    if (nStr == null || nStr == undefined || nStr == "" || nStr == 0)
      return "0.00";
    let no = parseInt(nStr).toFixed(2);
    /*if (no < 0) {
            nStr = no * -1;
        }
        nStr += '';*/

    let x = no.split(".");
    let x1 = x[0];
    let x2 = x.length > 1 ? "." + x[1] : "";
    let rgx = /(\d+)(\d{3})/;
    let z = 0;
    let len = x1.length;
    let num = len / 2 - 1;
    let newval = Math.floor(num);

    while (rgx.test(x1)) {
      if (z > 0) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      } else {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
        rgx = /(\d+)(\d{2})/;
      }
      z++;
      newval--;
      if (newval == 0) {
        break;
      }
    }

    let out = x1 + x2;
    if (Number(no) < 0) {
      out = "(" + out + ")";
    }
    return out;
  }

  calcTotal() {
    let designData = this.data.designList;
    let totalamt = 0.0;
    for (let i = 0; i < designData.length; i++) {
      let design = designData[i];
      totalamt += Number(design.amount);
    }
    if (isNaN(totalamt)) {
      totalamt = 0;
    }
    this.designdata.totalamt = parseFloat(totalamt.toFixed(2));
    this.designdata.totalamt = this.moneyFormat(this.designdata.totalamt);
  }

  calcMeter() {
    let designData = this.data.designList;
    let totalmtr = 0;
    for (let i = 0; i < designData.length; i++) {
      let design = designData[i];
      totalmtr += parseFloat(design.mtrs);
    }
    if (isNaN(totalmtr)) {
      totalmtr = 0;
    }
    this.designdata.totalmtr = parseFloat(totalmtr.toFixed(2));


  }
  calCShirt(ind) {

    if (this.designdata.width == '36')
      this.data.designList[ind].appr_shrts = (this.data.designList[ind].mtrs / 2.50).toFixed(0)
    else if (this.designdata.width == '44')
      this.data.designList[ind].appr_shrts = (this.data.designList[ind].mtrs / 1.80).toFixed(0)
    else
      this.data.designList[ind].appr_shrts = (this.data.designList[ind].mtrs / 1.60).toFixed(0)




  }
  onSelectItem($event, design, ind) {
    let design_no = _.filter(this.data.designList, {
      design_no: design.design_no,
      shade: design.shade,
    });

    if (design_no.length == 1) {
      if (design_no[ind].design_no != "" && this.designdata.style == 'CLUB' && design == 'each_clr_mtr') {
        this.onGoToNextFld($event, "main_fabmtr", ind);
      }
      else if (design_no[ind].design_no != "") {
        this.onGoToNextFld($event, "quality", ind);
      }
      else {
        this.onGoToNextFld($event, "variety_type", ind);
      }

    }
    else if (design.design_type != 'NEW') {
      if (this.designdata.style == 'CLUB')
        this.onGoToNextFld($event, "main_fabmtr", ind);
      else
        this.onGoToNextFld($event, "each_clr_mtr", ind);
    }
    else {
      // this.toasterService.pop({
      //   bodyOutputType: 1,
      //   type: "error",
      //   title: "ALREADY EXISTS",
      //   body: "Design with this shade Already Exists",
      // });
      swal({
        title: "ALREADY EXISTS?",
        type: "error",
        text: "Design with this shade Already Exists",
        confirmButtonText: "Ok!",
      });
      // design.design_no = "";
      design.shade = "";
    }
  }

  oncheckemptyrow() {
    if (this.designdata.totalmtr == null) {
      swal("Make sure that all the entries are given!");
    } else {
      let design = this.data.designList;
      let desList = [];
      for (let i = 0; i < design.length; i++) {
        if (design[i].design_no != "") {
          desList.push(design[i]);
        }
      }
      this.data.designList = desList;
      this.onSaveOrder();
    }
  }

  onSaveOrder(): void {
    /*  const list = this.data.designList,
        newList = [];
        for(let i=0;i<list.length;i++){
            const li = list[i],
            data = li.shade.split(',');
            for(let j=0; j<data.length; j++) {
                const newLi = Object.assign({},li);
                newLi.shade = data[j];
                newList.push(newLi);
            }
        } */
    this.mode = this.mode == 'Convert' ? 'Add' : this.mode;
    let params: any = Object.assign({}, this.designdata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.data.designList);
    params["mode"] = this.mode;

    params["po_date"] = this.datePipe.transform(
      params["po_date"],
      "yyyy-MM-dd"
    );
    params["date"] = this.datePipe.transform(params["date"], "yyyy-MM-dd");
    let that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to save this Order?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoading = true;
      that.poservice
        .saveOrder(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }

  loadeditdesignlist() {
    let params = {
      po_id: this.designdata.po_id,
    };
    this.poservice.getEditDesignList(params).then((res: any) => {
      this.data.designList = res.data;
      if (this.data.designList.length > 0) {
        this.designdata.less_value = parseFloat(this.data.designList[0].less_value);
      }

      this.designdata.less_value = this.temp;
      this.calcTotal();
      this.calcMeter();
    });
  }

  loadplainPoEst(id){
    let params = {
      ref_id: id,
    };
   this.salesServ.getplainPoentryDet(params).then((res : any) =>{
      this.data.designList = res.data

      this.data.designList.forEach((e,i) => {
         this.calctot("", i);
         this.calCShirt(i);
      });
      this.calcMeter();
   })
  }

  onClickCode(party_code) {
    let partyCodeList = _.filter(this.codeList, { code: party_code });
    if (partyCodeList.length > 0) {
      this.partyCodeList = partyCodeList;
      this.designdata.party_id = this.partyCodeList[0]["party_id"];
      this.coreGangList();
      this.getAgentList(this.designdata.party_id);
    } else {
      $("#partycode").focus();
      this.designdata.party_code = "";
      swal({
        title: "INVALID PARTY CODE",
        type: "error",
        text: "PLEASE ENTER VALID PARTY CODE",
        confirmButtonText: "Ok!",
      });
    }
  }
  onClickValidation(design_no, ind, element, arrayList) {
    let partyCodeList = arrayList.filter((el) => el.design_no == design_no);
    if (
      partyCodeList.length <= 0 &&
      this.data.designList[ind].design_no != ""
    ) {
      this.data.designList[ind].design_no = "";
      $("#" + element + "-" + ind).focus();
      swal({
        title: "INVALID DESIGN NO",
        type: "error",
        text: "PLEASE ENTER VALID DESIGN",
        confirmButtonText: "Ok!",
      });
    

    } else {
      this.data.designList[ind].rate = partyCodeList[0].party_rate;
    }
  }
  onClickLists(check_variable, ind, element, arrayList) {
    if (check_variable != "") {
      let existList = [];
      existList = arrayList.filter((el) => el.name == check_variable);
      if (element == 'variety') {
        existList = arrayList.filter((el) => el.variety == check_variable);
      }

      if (existList.length <= 0 && this.data.designList[ind][element] != "") {
        this.data.designList[ind][element] = "";
        $("#" + element + "-" + ind).focus();
        swal({
          title: "INVALID DATA",
          type: "error",
          text: "PLEASE ENTER VALID DATA",
          confirmButtonText: "Ok!",
        });
      } else if (element == 'color') {
        this.alphaNumRegex(this.shadeColor);
      } else if (element == 'variety') {
        if (this.designdata.style == 'RR FORMAL' || this.designdata.style == 'RR CASUAL') {
          // if (this.data.designList[ind]['variety_type'] == 'PLAIN') {

          this.data.designList[ind]['design_type'] = 'PLAIN';
        } else {
          this.data.designList[ind]['design_type'] = 'NEW';
        }

      }
    }
  }
  alphaNumRegex(shadeColor) {
    // if (
    //   (this.data.designList[this.shadeIndex].variety_type == "PLAIN") ||
    //   (shadeColor != "" && shadeColor != undefined)
    // ) 
    if (
      (this.designdata.style == 'RR FORMAL' || this.designdata.style == 'RR CASUAL') ||
      (shadeColor != "" && shadeColor != undefined)
    ) {
      // var regex = /^[a-zA-Z0-9]*$/;
      // if (regex.test(shade)) {
      this.addShade(shadeColor);
      return true;
      // } else {
      //   this.shadeType = "";
      //   $("#shadeType").focus();
      // }
    } else {
      swal("Please enter color");
    }
  }

  onClickAgent(agent_name) {
    let exists = this.purchaseAgentList.filter(
      (el) => el.agent_name == agent_name
    );

    if (exists && exists.length > 0) {
      this.designdata.agent_id = exists[0].agent_id;
    } else {
      swal("please enter valid agent name");
    }
  }
  gotoNextField(shadeType) {
    if (shadeType != "" || shadeType != undefined) {
      $("#shadeColor").focus();
    } else {
      $("#shadeType").focus();
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/purchaseOrder/addEditPurchaseOrder.ts